// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "src-frontend_components_Wrappers_Layout_index_js") return "" + chunkId + ".css";
	// return url for filenames based on template
	return "main.css";
};